// extracted by mini-css-extract-plugin
export default {"icon":"BackButton_icon__KLxO3"};